import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'aca-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.css']
})
export class AlertMessageComponent implements OnInit {

@Input() key;

  constructor(private msgService: MessageService) {
  }

  ngOnInit(): void {
  }

  // to clear the prompts
  onCloseIconClick(event: any) {
      this.msgService.clear();
  }

  // public methods for invocation
  displaySuccess(msg: string) {
      this.msgService.add({severity: 'success', summary: msg, closable: false, key: this.key, life: 1000, sticky: false });
  }

  displayInfo(msg: string) {
      this.msgService.add({severity: 'info', summary: msg, closable: false, key: this.key, life: 1000, sticky: false });
  }

  displayWarn(msg: string) {
      this.msgService.add({severity: 'warn', summary: msg, closable: false, key: this.key, life: 1000, sticky: false });
  }

  displayError(msg: string, err?: any) {
      this.msgService.add({severity: 'error', summary: msg, detail: err, closable: false, key: this.key, life: 1000, sticky: false });
  }

}
